__turbopack_context__.v({
  "checkbox": "OptionFieldInput-module-scss-module__ez0Osa__checkbox",
  "checked": "OptionFieldInput-module-scss-module__ez0Osa__checked",
  "disabled": "OptionFieldInput-module-scss-module__ez0Osa__disabled",
  "empty": "OptionFieldInput-module-scss-module__ez0Osa__empty",
  "error": "OptionFieldInput-module-scss-module__ez0Osa__error",
  "green": "OptionFieldInput-module-scss-module__ez0Osa__green",
  "greenRadio": "OptionFieldInput-module-scss-module__ez0Osa__greenRadio",
  "heart": "OptionFieldInput-module-scss-module__ez0Osa__heart",
  "indeterminate": "OptionFieldInput-module-scss-module__ez0Osa__indeterminate",
  "radio": "OptionFieldInput-module-scss-module__ez0Osa__radio",
  "root": "OptionFieldInput-module-scss-module__ez0Osa__root",
  "switch": "OptionFieldInput-module-scss-module__ez0Osa__switch",
  "thumb": "OptionFieldInput-module-scss-module__ez0Osa__thumb",
});
